import { OrganizationAuthMethodEnum } from 'src/api/main'
import { paths } from 'src/router'

import { SocialConnectCallbackPage } from './SocialConnectCallbackPage'

export const GoogleOrgConnectCallback = () => (
  <SocialConnectCallbackPage
    provider={OrganizationAuthMethodEnum.GOOGLE}
    flow="orgConnect"
    redirectPath={paths.auth.googleConnectCallback}
    successMessageKey="profileAuthMethods.connectSuccess"
  />
)
